<template>
	<v-container fluid>
		<v-layout row>
			<!-- Login Error Message -->
			<v-flex xs12>
				<v-alert
					transition="fade-transition"
					:value="showError"
					type="error"
					color="error"
					class="mb-4"
					>Could not send a reset password link</v-alert
				>

				<v-alert
					transition="fade-transition"
					:value="showSuccess"
					type="success"
					color="success"
					class="mb-4"
					>A password reset link has been sent to your email
					account!</v-alert
				>
			</v-flex>

			<v-flex xs12>
				<!-- Reset Password Form -->
				<v-form v-model="valid" class="form reset-password-form">
					<v-layout row>
						<v-flex xs12>
							<v-text-field
								v-model="forgotPasswordEmail"
								:rules="[rules.required, rules.email]"
								label="E-mail"
								required
							></v-text-field>
						</v-flex>

						<v-flex xs4 offset-xs9>
							<v-btn
								v-on:click="sendForgotPasswordEmail"
								style="
                                        background-color: var(--accent-color);
                                        color: var(--text-color-white)"
								>Submit</v-btn
							>
						</v-flex>
					</v-layout>
				</v-form>
			</v-flex>
		</v-layout>
	</v-container>
</template>

<!-- Script -->
<script>
import firebase from 'firebase/app';
import { setTimeout } from 'timers';
import Logger from '@/services/Logger.js';
export default {
	name: 'ResetPasswordForm',
	data: function() {
		return {
			valid: false,
			showSuccess: false,
			showError: false,
			forgotPasswordEmail: '',
			rules: {
				required: value => !!value || 'Required',
				email: value => /.+@.+/.test(value) || 'Invalid email'
			}
		};
	},
	methods: {
		sendForgotPasswordEmail: function() {
			const parent = this;
			firebase
				.auth()
				.sendPasswordResetEmail(this.forgotPasswordEmail)
				.then(function() {
					parent.showSuccess = true;
					setTimeout(() => {
						parent.showSuccess = false;
						parent.$emit('return-to-login');
					}, 4000);
				})
				.catch(function(error) {
					parent.showError = true;
					Logger.logError('Reset Password Failure', error);
					setTimeout(() => {
						parent.showError = false;
						parent.$emit('return-to-login');
					}, 4000);
				});
		}
	}
};
</script>
